export const workspace = {
  routes: [
    // TKP-176 md.61: çalışma alanı politika ekranları kalktı; eski bağlantılar Tedbirler'e
    { path: "/workspace/library/policy", redirect: "/workspace/library/measure" },
    { path: "/workspace/library/policy-group", redirect: "/workspace/library/measure" },
  ],
};
export const management = {
  routes: [
    {
      path: "/management/policy",
      component: () => import("../management-library-policy-view"),
    },
    {
      path: "/management/policy-group",
      component: () => import("../management-library-policy-group-view"),
    },
  ],
};

// TKP-147 / tasarım s.35 md.5,7 (s.20 md.4): ekran kalktı; eski adres panelin açılış sayfasına yönlenir. Backend, veri ve raporlar yerinde.
export const gdpr = {
  routes: [
    { path: "/gdpr/policy", redirect: "/gdpr/entities" },
    { path: "/gdpr/policy-detail/:id", redirect: "/gdpr/entities" },
  ],
};
export const kvkk = {
  routes: [
    { path: "/kvkk/policy", redirect: "/kvkk/entities" },
    { path: "/kvkk/policy-detail/:id", redirect: "/kvkk/entities" },
  ],
};
export const ddo = {
  routes: [
    { path: "/ddo/policy", redirect: "/ddo/roadmap" },
    { path: "/ddo/policy-detail/:id", redirect: "/ddo/roadmap" },
  ],
};
export const bgys = {
  routes: [
    { path: "/bgys/policy", redirect: "/bgys/roadmap" },
    { path: "/bgys/policy-detail/:id", redirect: "/bgys/roadmap" },
  ],
};
export const organization = {
  routes: [
    { path: "/organization/policy", redirect: "/organization" },
    { path: "/organization/policy-detail/:id", redirect: "/organization" },
  ],
};
